import { ReactNode, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUserProfile } from '~/hooks/useCurrentUserProfile';
import { buildPermissionSet, hasPermission } from '~/lib/permissions';
import { ROUTES } from '~/utils/constants';

/** Sends users with `cn03_form_view_rg` to the RG manage screen instead of `/app/cn03-manage`. */
export function RedirectCn03RgFromManage({ children }: { children: ReactNode }) {
  const { data } = useCurrentUserProfile();
  const permissionSet = useMemo(
    () => buildPermissionSet(data?.permissions),
    [data?.permissions]
  );

  if (hasPermission(permissionSet, 'cn03_form_view_rg')) {
    return <Navigate to={ROUTES.CN03_MANAGE_RG} replace />;
  }

  return <>{children}</>;
}
